import React from "react";

import LockIcon from "@mui/icons-material/Lock";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./Lock.module.css";

interface Props {
  isLocked: boolean;
  onPress: () => void;
}

const Lock: React.FC<Props> = ({ isLocked, onPress }) => {
  return (
    <div
      className={toClassName(styles.container, {
        [styles.containerLocked]: isLocked,
        [styles.containerUnlocked]: !isLocked,
      })}
      onClick={onPress}
    >
      <LockIcon
        className={toClassName(styles.icon, {
          [styles.iconLocked]: isLocked,
          [styles.iconUnlocked]: !isLocked,
        })}
      />
    </div>
  );
};

export default Lock;
